import { createClient } from 'contentful'
import { get, some, map, find, set, pick } from 'lodash'

let staff = []
let posts = []
let tags = []
let totalPosts = 0
let homeFeatures = []

const client = createClient({
  space: '29rcs1d1r6x8',
  accessToken: 'WifZ3Ry7ul5i6jszh_tcuGGGQ951Wq4JExIpRvIYyfo',
})

const getStaff = async (params) => {
  const { force = false } = params || {}
  if (some(staff) && !force) return
  try {
    const response = await client.getEntries({
      content_type: 'person',
      order: 'fields.order,sys.createdAt',
    })
    const assets = get(response, 'includes.Asset')
    const items = get(response, 'items', [])
    staff = map(items, person => {
      const imageId = get(person, 'fields.image.sys.id')
      const image = find(assets, { sys: { id: imageId }})
      const photoUrl = get(image, 'fields.file.url')
      const obj = pick(person.fields, ['name', 'title', 'photoUrl', 'shortBio'])
      return { ...obj, photoUrl }
    })
    console.log(staff)
  } catch (e) {
    console.log(e.message)
  }
}

const getPosts = async (params) => {
  const { limit = 1, skip = 0 } = params || {};
  try {
    const response = await client.getEntries({
      content_type: 'blogPost',
      order: '-fields.publishDate',
      limit,
      skip,
    })
    const items = get(response, 'items', [])
    const assets = get(response, 'includes.Asset', [])
    totalPosts = get(response, 'total', 0)
    posts = map(items, post => {
      const imageId = get(post, 'fields.heroImage.sys.id')
      const image = find(assets, { sys: { id: imageId }})
      const imageUrl = get(image, 'fields.file.url')
      const obj = pick(post.fields, ['title', 'body', 'slug', 'videoUrl', 'publishDate'])
      return { ...obj, imageUrl }
    })
    imba.commit()
    console.log(posts)
  } catch (e) {
    console.log(e.message)
  }
}

const getHomeFeatures = async (params) => {
  const { force = false } = params || {}
  if (some(homeFeatures) && !force) return
  try {
    const response = await client.getEntries({
      content_type: 'homeFeature',
      'fields.active': true,
      order: 'fields.order',
    })
    const assets = get(response, 'includes.Asset', [])
    const items = get(response, 'items', [])
    homeFeatures = map(items, feature => {
      const imageId = get(feature, 'fields.image.sys.id')
      const image = find(assets, { sys: { id: imageId }})
      const imageUrl = get(image, 'fields.file.url')
      const obj = pick(feature.fields, ['title', 'body', 'mapEmbedUrl', 'phone', 'buttonLabel', 'buttonUrl', 'buttonStyle', 'order'])
      return { ...obj, imageUrl }
    })
    imba.commit()
  } catch (e) {
    console.log(e.message)
  }
}

const getTags = async (params) => {
  const { force = false } = params || {};
  if (some(tags) && !force) return
  try {
    const response = await client.getTags();
    tags = map(response.items, 'name')
    console.log(tags)
  } catch (e) {
    console.log(e.message)
  }
}

export { staff, getStaff, posts, getPosts, totalPosts, tags, getTags, homeFeatures, getHomeFeatures }